import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

const transformBankAccountField = _ref => {
  let {
    required,
    keyboard_input_type,
    format,
    min_length,
    max_length,
    adjust_pattern
  } = _ref;
  return {
    required,
    keyboardInputType: keyboard_input_type,
    format,
    minLength: min_length,
    maxLength: max_length,
    adjustPattern: adjust_pattern
  };
};

const transformBankAccountFields = fields => Object.keys(fields).reduce((acc, fieldType) => {
  const dtoField = fields[fieldType];
  return _objectSpread(_objectSpread({}, acc), {}, {
    [fieldType]: dtoField ? transformBankAccountField(dtoField) : null
  });
}, {});

export const transformBankAccountRegistration = _ref2 => {
  let {
    provider_name,
    account_type,
    info,
    tokenizer,
    fields
  } = _ref2;
  return {
    provider: provider_name,
    accountType: account_type,
    tokenizer: tokenizer,
    info: {
      country: info.country,
      currency: info.currency
    },
    fields: transformBankAccountFields(fields)
  };
};